const styles = ({ palette }) => ({
  bigAvatar: {
    borderRadius: 4,
    display: 'none',
    fontSize: 38,
    height: 64,
    width: 64,
    backgroundColor: palette.avatar.grayLarge,
    color: palette.text.strong,
    '@media (min-width: 800px)': {
      display: 'flex',
    },
  },
  body: {
    backgroundColor: palette.background.paper,
    padding: '25px 25px',
  },
  boldTypography: {
    fontWeight: 500,
  },
  chip: {
    backgroundColor: palette.background.hintSubtle,
  },
  defaultOverride: {
    color: palette.text.strong,
    cursor: 'default',
    borderBottom: `0.5px solid ${palette.background.elevated}`,
    '& .Mui-disabled': {
      WebkitTextFillColor: palette.text.strong,
    },
  },
  ellipsedText: {
    maxWidth: 300,
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  ellipsedWrapText: {
    maxWidth: 200,
  },
  header: {
    backgroundColor: palette.background.subtle,
    padding: 25,
  },
  headerSpace: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
  },
  nextDate: {
    marginTop: 18,
  },
  positiveAmount: {
    color: 'green',
  },
  underlineOverride: {
    '&:before': {
      borderBottom: `1px solid ${palette.background.elevated}`,
    },
  },
  closeButton: {
    padding: 0,
  },
  deleteButton: {
    width: 36,
    minWidth: 36,
    marginLeft: 8,
  },
});

export default styles;
